var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_71_3252",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_71_3252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.65 15.5333L12.6667 14.55C12.5556 14.5833 12.4472 14.6111 12.3417 14.6333C12.2361 14.6555 12.1222 14.6666 12 14.6666H4.00001C3.44446 14.6666 2.97223 14.4722 2.58335 14.0833C2.19446 13.6944 2.00001 13.2222 2.00001 12.6666V10.6666H4.00001V5.88331L0.450012 2.33331L1.40001 1.38331L14.6 14.5833L13.65 15.5333ZM4.00001 13.3333H11.45L10.1167 12H3.33335V12.6666C3.33335 12.8555 3.39723 13.0139 3.52501 13.1416C3.65279 13.2694 3.81112 13.3333 4.00001 13.3333ZM14 12.1166L12.6667 10.7833V3.33331H5.21668L4.00001 2.11665V1.33331L5.00001 2.33331L6.00001 1.33331L7.00001 2.33331L8.00001 1.33331L9.00001 2.33331L10 1.33331L11 2.33331L12 1.33331L13 2.33331L14 1.33331V12.1166ZM5.33335 10.6666H8.78335L5.33335 7.21665V10.6666ZM7.91668 5.99998L6.58335 4.66665H10V5.99998H7.91668ZM9.91668 7.99998L8.58335 6.66665H10V7.99998H9.91668ZM11.3333 7.99998C11.1445 7.99998 10.9861 7.93609 10.8583 7.80831C10.7306 7.68054 10.6667 7.5222 10.6667 7.33331C10.6667 7.14442 10.7306 6.98609 10.8583 6.85831C10.9861 6.73054 11.1445 6.66665 11.3333 6.66665C11.5222 6.66665 11.6806 6.73054 11.8083 6.85831C11.9361 6.98609 12 7.14442 12 7.33331C12 7.5222 11.9361 7.68054 11.8083 7.80831C11.6806 7.93609 11.5222 7.99998 11.3333 7.99998ZM11.3333 5.99998C11.1445 5.99998 10.9861 5.93609 10.8583 5.80831C10.7306 5.68054 10.6667 5.5222 10.6667 5.33331C10.6667 5.14442 10.7306 4.98609 10.8583 4.85831C10.9861 4.73054 11.1445 4.66665 11.3333 4.66665C11.5222 4.66665 11.6806 4.73054 11.8083 4.85831C11.9361 4.98609 12 5.14442 12 5.33331C12 5.5222 11.9361 5.68054 11.8083 5.80831C11.6806 5.93609 11.5222 5.99998 11.3333 5.99998Z",
    fill: "#056D62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveNote);
export default __webpack_public_path__ + "static/media/removeNote.dc49e9e28bd9d4585c0115925930c7ab.svg";
export { ForwardRef as ReactComponent };